import React, { useEffect, useState } from 'react';
import { Flame, ChevronRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { PRE_REGISTRO_2027_URL } from '../config/constants';
import { usePreregistroCount, trackPreregistroClick } from '../hooks/usePreregistroCount';

const StickyPreregistroBar = () => {
  const { language } = useLanguage();
  const isES = language === 'es';
  const count = usePreregistroCount();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-0 inset-x-0 z-40 transition-transform duration-300 ${visible ? 'translate-y-0' : 'translate-y-full'}`}
      data-testid="sticky-preregistro-bar"
      aria-hidden={!visible}
    >
      <div className="bg-[#071528]/95 backdrop-blur-md border-t border-[#D4AF37]/30 px-3 py-2.5 flex items-center gap-3 shadow-[0_-10px_30px_rgba(0,0,0,0.35)]">
        <div className="flex-1 min-w-0 leading-tight">
          <div className="text-[10px] font-black uppercase tracking-widest text-[#D4AF37]">{isES ? '21ª Convención · 2027' : '21st Convention · 2027'}</div>
          <div className="text-xs text-white/80 truncate">
            {count !== null ? (
              <><span className="text-white font-black tabular-nums" data-testid="sticky-preregistro-count">+{count}</span> {isES ? 'ya se pre-registraron' : 'already pre-registered'}</>
            ) : (isES ? 'Sé de los primeros en enterarte' : 'Be among the first to know')}
          </div>
        </div>
        <a
          href={PRE_REGISTRO_2027_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={trackPreregistroClick}
          data-testid="sticky-preregistro-cta"
          className="reservar-cta shrink-0 inline-flex items-center gap-1.5 bg-[#FF6B35] hover:bg-[#E55A28] text-white font-black text-sm px-4 py-2.5 rounded-full shadow-[0_8px_24px_rgba(255,107,53,0.45)]"
        >
          <Flame className="w-4 h-4" />
          {isES ? 'Pre-regístrate' : 'Pre-register'}
          <ChevronRight className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
};

export default StickyPreregistroBar;
